import React, {useState, useEffect} from "react";
import { useStaticQuery, graphql } from "gatsby"
import PropertyAreas from "./DynamicPopularSearch/PropertyAreas"
import PropertyBedrooms from "./DynamicPopularSearch/PropertyBedrooms"
import PropertyTypes from "./DynamicPopularSearch/PropertyTypes"
import PropertyStaticPages from "./DynamicPopularSearch/PropertyStaticPages"

const PopularSearchComponent = (props) => {

    const[showList, setShowList] = useState(false);

    const handleShow = event => {
        event.currentTarget.classList.toggle('active-menu');
        setShowList(!showList)
    };

    //console.log("searchParams", props.searchParams)

    const data = useStaticQuery(graphql`
        query PropertyTypeQuery{
            glstrapi {
                propertySearch {
                    property_type {
                      id
                      label
                      value
                      department
                    }
                }
            }
        }
    `)

    var property_type_list = data?.glstrapi.propertySearch.property_type;

    let searchParams = props.searchParams;

    //console.log("searchParams", searchParams);


    return (
        <>
            <div className="menu-list popular">
                <div className="heading-wrap">
                    <h5>Popular Searches</h5>

                    <button onClick={handleShow} >
                        <i className="icon-dropdown"></i>
                    </button>
                </div>
                
                <div className={`top-menu ${showList ? "" : "d-none"}`}>
                    {searchParams.bedrooms && searchParams.propertyType ?
                        <>
                            <PropertyAreas searchParams={searchParams} property_type_list={property_type_list} />                            
                            <PropertyTypes searchParams={searchParams} property_type_list={property_type_list}/>
                            <PropertyBedrooms searchParams={searchParams} property_type_list={property_type_list}/>
                            {searchParams.department &&
                                <PropertyStaticPages searchParams={searchParams} property_type_list={property_type_list} page_slug={searchParams.department === "commercial" ? (  searchParams.propertyType ? "commercial-search-result-propert-type" : "commercial-search-result") : "search-result"}/>
                            }
                        </>
                    :
                        <>
                            <PropertyAreas searchParams={searchParams} property_type_list={property_type_list}/>
                            <PropertyBedrooms searchParams={searchParams} property_type_list={property_type_list}/>
                            <PropertyTypes searchParams={searchParams} property_type_list={property_type_list}/>
                            {searchParams.department &&
                                <PropertyStaticPages searchParams={searchParams} property_type_list={property_type_list} page_slug={searchParams.department === "commercial" ? ( searchParams.propertyType ? "commercial-search-result-propert-type" : "commercial-search-result") : "search-result"}/>
                            }
                        </>
                    }
                </div>
            </div>
        </>
    )
}
export default PopularSearchComponent;